var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "rb-anchor",
    { staticClass: "rb-popular-search", on: { click: _vm.onClick } },
    [
      _c(
        "button",
        {
          staticClass: "rb-popular-search__item",
          attrs: { type: "button", "mnt-data-category": _vm.category },
        },
        [_vm._v("\n    " + _vm._s(_vm.searchTerm) + "\n  ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }